import type { CapiProductPage } from 'types/capi/pdp';

import SocialIcon from '~/assets/icons/Social';
import Content from '~/components/Content';
import PopoutContainer from '~/components/PopoutContainer';
import usePageData from '~/hooks/usePageData';

const SocialSection = () => {
  const { social_info_content } = usePageData<CapiProductPage>();

  return (
    <PopoutContainer>
      <div className="flex items-center justify-center gap-4">
        <div className="w-10">
          <SocialIcon width="24" height="24" />
        </div>
        <Content content={social_info_content} />
      </div>
    </PopoutContainer>
  );
};

export default SocialSection;
